/**
 * 文档管理 相关菜单配置
 *
 */

import { lazyLoad } from "@/utils/lazyLoad";
const documentManageRoute = [
  {
    component: lazyLoad,
    path: "/document-manage",
    name: "documentManage",
    meta: {
      title: "文档管理",
      icon: "icon-document",
      code: "document-manage",
    },
    children: [
      {
        path: "/document/library",
        name: "documentManageLibrary",
        component: () => import("../pages/documentManage/library/index.vue"),
        meta: {
          title: "文档库",
          keepAlive: false,
        },
      },
    ],
  },
];
export default documentManageRoute;
